import React, { useEffect, useState } from 'react';
import { Form  } from 'react-final-form';

import { FormCheckbox } from '../../elements/Form';
import { Button } from '../../elements';
import { ReactComponent as SaveIcon } from '../../styles/icon/save.svg';
import { useAppDispatch } from '../../hooks/useRedux';
import { appsActions } from '../../redux/reducers/apps';
import { setLoading } from '../../redux/loading/loadingActions';
import { showError, showSuccess } from '../../elements/Toasts/toastActions';
import strings from '../../lang/lang';
import { ApiInformation } from '../../api/portal/portalApi';

import styles from './PermissionForm.module.scss';

interface IPermissions {
  appId: string;
  redirectUris: string[];
  permissionList: Array<ApiInformation>;
  initialUris: string[];
}

function PermissionForm(props: IPermissions) {
  const [isNewRedirectUri, handleSubmiteButton] = useState(true);
  const { permissionList, redirectUris, appId, initialUris } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    handleSubmiteButton(ignoreOrderCompare(initialUris, redirectUris));
  }, [initialUris, redirectUris]);

  function getInitialScopes() {
    const scopes: string[] = [];
    permissionList.forEach((c) => {
      if (c.hasPermission) {
        scopes.push(c.id);
      }
    });
    return scopes;
  }

  function addScopeDescription(selectedScopes) {
    const scopesWithDesc: string[] = [];
    selectedScopes.forEach((c) => {
      const scope: any = permissionList.find((cc) => cc.id === c);
      const desc = scope.scopeDescription.default || null;
      scopesWithDesc.push(c + '|' + desc);
    });
    return scopesWithDesc;
  }

  function ignoreOrderCompare(a: string[], b: string[]): boolean {
    if (a.length !== b.length) return false;
    const elements: any = new Set([...a, ...b]);
    for (const x of elements) {
      const count1 = a.filter((e) => e === x).length;
      const count2 = b.filter((e) => e === x).length;
      if (count1 !== count2) return false;
    }
    return true;
  }

  function onSubmit(values) {
    const scopes = addScopeDescription(values.scopes);
    return new Promise((res, rej) => {
      dispatch(appsActions.updateAppDetails({ appId, data: { redirectUris, scopes }, res, rej }));
    })
    .then(() => {
      showSuccess(strings.appPermissions.text.saved);
    })
    .catch(() => {
      showError(strings.appPermissions.errors.savingPermissions);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        scopes: getInitialScopes(),
      }}
      render={({ handleSubmit, values }) => {
        const nextScopes = values.scopes;
        const prevScopes = getInitialScopes();
        const disable = ignoreOrderCompare(prevScopes, nextScopes);
        return (
          <form onSubmit={handleSubmit}>
            <div className={styles.permissionForm__wrap}>
              {permissionList.map((c, i) => (
                <div key={i} className={styles.permissionForm__row}>
                  <FormCheckbox
                    className="permissionForm"
                    name="scopes"
                    value={c.id}
                    checked={c.hasPermission}
                    label={c.headerName}
                  />
                </div>
              ))}
            </div>
            <div>
              <Button
                name={'Save'}
                variant="primary"
                secondaryClassName="lg"
                type="submit"
                disabled={isNewRedirectUri && disable}
              >
                <SaveIcon />
              </Button>
            </div>
          </form>
        );
      }}
    />
  );
}

export default PermissionForm;
